import { ChangeEvent } from "react";

export const createOnChangeEvent = (name: string, value: any) => {
    return {
        target: {
            name: name,
            value: value,
        },
    } as ChangeEvent<any>;
};
